module.exports = __webpack_public_path__ + "static/img/mind_kwh_main.fb9d86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/products/mind_kwh_main.png
// module id = 8xG3
// module chunks = 1